import React from 'react';

import BirthRegistrationForm from './../component/BirthRegistrationForm/BirathRegistrationForm';
 export default function BirthRegistration()
 {
   return(
     <>
     <BirthRegistrationForm/>
     </>
   )
 }